import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../../../core/services/app.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { EventEmitterService } from '../../../../core/services/event-emitter.service';
import { ThemeConfigService } from '../../../../core/services/theme-config.service';
import { GlobalVariableService } from '../../../../core/services/global-variable.service';

@Component({
    selector: 'subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.scss']
})
export class SubheaderComponent implements OnInit {

    @Input() title: string;
    @Input() breadcrumb: any[];
    listCampagne: any;
    stat_preparation: any;
    percentage_preparation: any;
    stat_execution: any;
    percentage_execution: any;
    stat_arbitrage: any;
    percentage_arbitrage: any;
    typeView: any;
    stateDashboardOfa: boolean;
    urlActive: any;
    user: any;
    constructor(
        private _router: Router,
        private _app: AppService,
        private storage: LocalStorageService,
        private variable: GlobalVariableService,
        private _loading: LoadingBarService,
        private eventEmitter: EventEmitterService,
        private themeConfigService: ThemeConfigService
        ) { }

    ngOnInit() {
        // this.getAllCampagneOfa(); /* Mis en commentaire pdt l'EIA */
        this.user = JSON.parse(this.variable.getUser());
        this.urlActive = this.themeConfigService.getModel(this._router.url);
    }

    getAllCampagneOfa() {
        this._loading.start();
        this._app.getData('campagne/ofa/all')
            .subscribe(
                res => {
                    if (res.error === false) {
                        this._loading.stop();
                        this.listCampagne = res.data;
                        this.listCampagne.forEach((element) => {
                            this.stat_preparation = element.pourcentage_preparation;
                            this.percentage_preparation = element.pourcentage_preparation + '%';
                            this.stat_execution = element.pourcentage_execution;
                            this.percentage_execution = element.pourcentage_execution + '%';
                            this.percentage_arbitrage = element.pourcentage_arbitrage + '%';
                            this.stat_arbitrage = element.pourcentage_arbitrage;
                        });
                    } else {
                        this._loading.stop();
                    }
                }, err => {
                    this._loading.stop();
                }
            );
    }

    // goToCampagneOfa() {
    //     this._router.navigate(['/campagne/initialisation-ofa']);
    // }
}
